<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="terms">
      <div class="main-content">
        <div class="page-width pre-formatted">
          <div class="section-header text-center">
            <h1>{{ $t('FAQ') }}</h1>
          </div>
          <!-- <p>{{ companyTerms }}</p> -->
          <div class="terms-list">
            <p>Q: My order came in damaged. How do I proceed?</p>
            </br>
            <p>A: Elegant Granite is responsible for products damaged during transit. Please contact customer service via email. uscabinetsworld@gmail.com</p>
          </div>
          <div class="terms-list">
            <p>Q: My order melted during transit. Will I get a refund?</p>
            </br>
            <p>A: Unfortunately Elegant Granite cannot be held responsible for melting issues. Chocolate products will melt in hot weather during transit. Please do not order if the area you are expecting delivery is experiencing hot weather.</p>
          </div>
          <div class="terms-list">
            <p>Q: Will I be able to return food and beverage products?</p>
            </br>
            <p>A: Elegant Granite does not accept returns on food and beverage, unless the products are damaged during transit. (Please note products melted during transit cannot be returned as damaged).</p>
          </div>
          <div class="terms-list">
            <p>Q: Will I be able to return nonfood items?</p>
            </br>
            <p>A: Elegant Granite accepts nonfood returns. Any products sold under the SMARTS and WANTS categories are considered to be nonfood products. Please note that customers will be responsible for returning freight expense plus a restocking fee of 15% of the returned product.</p>
          </div>
          <div class="terms-list">
            <p>Q: I have a question that is not answered by our FAQ page. How do I proceed?</p>
            </br>
            <p>A: Please contact customer support service via email for all other questions. uscabinetsworld@gmail.com</p>
          </div>
          <div class="terms-list">
            <p>Q: How fast my order will be delivered to me?</p>
            </br>
            <p>A: We use FedEx Ground to ship your orders. It takes 1-5 business days to deliver a package. You can check the order details for a FedEx tracking number.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb'
import { Config } from '../../../config/default';
export default {
  name: "faq",
  components: {
    breadcrumb,
  },
  data() {
    return {
      companyPrivacyPolicy: Config.COMPANY_PRIVACY_POLICY,
      path2: this.$t('FAQ'),
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/terms.less";
</style>



// WEBPACK FOOTER //
// src/view/Footer/faq.vue